module.exports = __webpack_public_path__ + "static/img/8.2dd5e29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/8.png
// module id = fzRK
// module chunks = 0